import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

const NosotrosPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const values = [
    {
      title: 'Honestidad',
      description: 'Actuamos de manera confiable, cumpliendo con nuestro deber y de acuerdo con la moral, especialmente con la transparencia a nuestros clientes.',
      icon: 'ri-shield-check-line',
    },
    {
      title: 'Responsabilidad',
      description: 'Trabajamos en equipo con un enfoque de servicio y de valor, tomando en cuenta los detalles.',
      icon: 'ri-team-line',
    },
    {
      title: 'Lealtad',
      description: 'Somos fieles a nuestros principios y compromisos establecidos con nuestros clientes.',
      icon: 'ri-hand-heart-line',
    },
    {
      title: 'Veracidad',
      description: 'Nos conducimos con verdad, siempre bajo la realidad según cada cliente.',
      icon: 'ri-checkbox-circle-line',
    },
    {
      title: 'Compromiso',
      description: 'Llegamos al acuerdo realizado con nuestros clientes, en tiempo y forma, según la necesidad.',
      icon: 'ri-time-line',
    },
    {
      title: 'Objetividad',
      description: 'Somos sensibles al cambio y respondemos en forma organizada, cumpliendo día a día nuestra Misión y Visión.',
      icon: 'ri-focus-3-line',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <WhatsAppButton />

      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-primary-dark to-primary-light">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-5xl md:text-6xl text-white mb-6">Nosotros</h1>
          <p className="font-body text-xl text-white/90 max-w-3xl mx-auto">
            Conoce más sobre nuestra empresa y nuestro compromiso con la excelencia
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="font-heading font-bold text-4xl text-primary mb-6">¿Quiénes Somos?</h2>
              <div className="w-24 h-1 bg-gold mb-8"></div>
              <p className="font-body text-base text-gray-700 leading-relaxed mb-6">
                <strong>KRONOS CEO Consultores S.C.</strong> es una sociedad mexicana conformada por un grupo de profesionales enfocados a brindar sus conocimientos de manera ética y profesional para dar soluciones y proporcionar servicio de calidad a cada uno de nuestros clientes.
              </p>
              <p className="font-body text-base text-gray-700 leading-relaxed mb-6">
                Brindamos consultoría personalizada en tiempo y forma para cumplir con sus obligaciones fiscales, siendo una empresa especializada en resolver y prevenir riesgos financieros, contables, administrativos y fiscales, mediante herramientas tecnológicas.
              </p>
              <div className="grid grid-cols-2 gap-6 mt-8">
                <div className="bg-gray-50 rounded-lg p-6">
                  <div className="font-heading font-bold text-3xl text-gold mb-2">86,400</div>
                  <div className="font-body text-sm text-gray-600">Horas de Consultoría</div>
                </div>
                <div className="bg-gray-50 rounded-lg p-6">
                  <div className="font-heading font-bold text-3xl text-gold mb-2">5+</div>
                  <div className="font-body text-sm text-gray-600">Años de Experiencia</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://kronoscc.com/wp-content/uploads/2025/02/kcc_logo_individual.png"
                alt="Kronos CEO Consultores"
                className="w-full rounded-xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div className="bg-white rounded-xl p-10 shadow-lg">
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-primary"></i>
              </div>
              <h2 className="font-heading font-bold text-3xl text-primary mb-6">Nuestra Visión</h2>
              <div className="w-24 h-1 bg-gold mb-6"></div>
              <p className="font-body text-base text-gray-700 leading-relaxed">
                Ser una consultoría sobresaliente en las áreas contable, fiscal, administrativa y automatización de procesos, brindando soluciones reales y efectivas de manera honesta, responsable y comprometida con nuestros clientes.
              </p>
            </div>

            <div className="bg-white rounded-xl p-10 shadow-lg">
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-3xl text-primary"></i>
              </div>
              <h2 className="font-heading font-bold text-3xl text-primary mb-6">Nuestra Filosofía</h2>
              <div className="w-24 h-1 bg-gold mb-6"></div>
              <p className="font-body text-base text-gray-700 leading-relaxed">
                Ofrecer cada uno de nuestros servicios con ética profesional, calidad, compromiso y oportunidad para cada uno de nuestros clientes.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading font-bold text-4xl md:text-5xl text-primary mb-4">Nuestros Valores</h2>
            <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
            <p className="font-body text-lg text-gray-700 max-w-3xl mx-auto">
              Los principios que guían nuestro trabajo diario
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-2"
              >
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-2xl text-primary`}></i>
                </div>
                <h3 className="font-heading font-bold text-xl text-primary mb-4">{value.title}</h3>
                <p className="font-body text-sm text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-white mb-6">
            ¿Listo para trabajar con nosotros?
          </h2>
          <p className="font-body text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Contáctanos hoy y descubre cómo podemos ayudarte a alcanzar tus objetivos
          </p>
          <a
            href="/contacto"
            className="inline-block px-8 py-4 bg-gold hover:bg-gold/90 text-primary font-heading font-bold text-base rounded-lg transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap"
          >
            Contáctanos Ahora
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NosotrosPage;